import type { IReportState } from '@/store/modules/report/types';

export const state: IReportState = {
  reports: [],
};
